import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const projectId = process.env.REACT_APP_FB_PROJECT_ID;
const apiKey = process.env.REACT_APP_FB_API_KEY;
const messagingSenderId = process.env.REACT_APP_FB_MESSAGING_SENDER_ID;
const appId = process.env.REACT_APP_FB_APP_ID;

const config = {
  apiKey,
  authDomain: `${projectId}.firebaseapp.com`,
  databaseURL: `https://${projectId}.firebaseio.com`,
  projectId,
  storageBucket: `${projectId}.appspot.com`,
  messagingSenderId,
  appId,
};

const app = initializeApp(config, "scoreboard");
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
